import React, {useMemo, useState} from "react";
import Global from "@assets/images/icons/global.svg";
import {Menu, MenuItem} from "@mui/material";
import Fade from "@mui/material/Fade";

/* eslint-disable no-unused-vars */

import "../header.sass";
import {Button} from "@components/library";
import {useDispatch} from "react-redux";
import {LOCALE} from "@constants";
import {useTranslation} from "@helpers/translate";
import config from "../../../../config";
import {LANGUAGES} from "@constants/languages";
import {toggleLoginModal, toggleSignUpModal} from "@actions/authModalsActions";
import {useLocation} from "react-router-dom";

const Unauthorized = (props) => {
  const [anchorEl, setAnchorEl] = useState(false);
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const {__} = useTranslation();
  const location = useLocation();
  const currentPath = location.pathname;
  const isAuthRoute = useMemo(() => currentPath.startsWith("/auth/"), [currentPath]);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event) => {
    setAnchorEl(null);
    const {myValue} = event.currentTarget.dataset;
    dispatch({type: LOCALE.CHANGE_LOCALE, payload: myValue});
  };

  const handleSignUpToggle = (isOpen) => {
    dispatch(toggleSignUpModal(isOpen));
  };

  const handleLoginToggle = (isOpen) => {
    dispatch(toggleLoginModal(isOpen));
  };

  return (
    <div className="header__right">
      <nav>
        <ul className="header__nav-list">
          <li className="header__nav-item">
            <Button
              type={!isAuthRoute ? "button" : "link"}
              className="header__login header__btn"
              color="black"
              size="mini"
              {...(!isAuthRoute
                ? {onClick: () => handleLoginToggle(true)}
                : {to: "/auth/login"})}
            >
              {__("login.button.title")}
            </Button>
          </li>
          <li className="header__nav-item">
            <Button
              type={!isAuthRoute ? "button" : "link"}
              className="header__signUp header__btn"
              color="white"
              size="mini"
              {...(!isAuthRoute
                ? {onClick: () => handleSignUpToggle(true)}
                : {to: "/auth/signup"})}
            >
              {__("auth.sign_up")}
            </Button>
          </li>
          <li className="header__nav-item">
            <div>
              <button
                onClick={handleClick}
                type="button"
                className="header__mini-btn"
              >
                <img src={Global} alt="lang"/>
              </button>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                className="mini-select"
              >
                {LANGUAGES.filter((language) =>
                  config.supported_locales.includes(language.code),
                ).map(({code, name, Flag}) => (
                  <MenuItem key={code} data-my-value={code} onClick={handleChange}>
                    <div className="header__change-btn">
                      <Flag className="header__change-btn-flag"/>
                      <p className="header__change-btn-text">{name}</p>
                    </div>
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Unauthorized;
